<div class="popup-overlay" (click)="closeEvent()"></div>

<div class="cal-event-popup">
  <svg width="15" height="25" viewBox="0 0 15 25" class="popup-arrow">
    <path d="M14.0003 11.382C14.6669 11.9783 14.6669 13.0217 14.0003 13.618L3.02616 23.4349C2.05986 24.2993 0.526087 23.6134 0.526087 22.3169L0.526087 2.68311C0.526088 1.3866 2.05986 0.700743 3.02616 1.56515L14.0003 11.382Z" fill="currentColor" stroke="currentColor"/>
  </svg>

  <div class="event-content">
    <div class="close-btn-box">
      <button class="no-style close-btn" (click)="closeEvent()">
        <mat-icon [svgIcon]="'close'" class="square-icon close-icon"></mat-icon>
      </button>
    </div>

    <h4 *ngIf="event.eventData.linkUrl; else linkTitleBlock" class="ellipsis-text event-title">
      <a [attr.href]="event.eventData.linkUrl" target="_blank">{{ event.title }}</a>
    </h4>
    <ng-template #linkTitleBlock>
      <h4 class="ellipsis-text event-title">{{ event.title }}</h4>
    </ng-template>
    

    <div class="event-date">
      <mat-icon [svgIcon]="'clock'" class="square-icon event-icon"></mat-icon>

      {{ event.eventData.date | date: "dd/MM/yyyy" }}<br/>
      <span *ngIf="!isTimeEmpty(event.eventData.date)">{{ event.eventData.date.replace('Z', '') | date: "HH:mm" }}</span>
    </div>

    <div class="separator"></div>

    <div>
      <span *ngIf="event.eventData.mainLecturerName">{{event.eventData.mainLecturerName}}<br/></span>
      <span *ngIf="event.eventData.name">{{event.eventData.name}}</span>
      <span *ngIf="event.eventData.name && event.eventData.description"> | </span>
      <span *ngIf="event.eventData.description">{{event.eventData.description}}</span>
    </div>

    <div *ngIf="event.eventData.location" class="event-location">
      <mat-icon [svgIcon]="'location'" class="square-icon event-icon"></mat-icon>
      <span *ngIf="event.eventData.gpsX; else locationMapText">
        <a class="event-location-text" (click)="locatinPicker.openMapsModal()">{{event.eventData.location}}</a>
      </span>
      <ng-template #locationMapText>
        <div class="event-location-text">
          {{event.eventData.location}}
        </div>
      </ng-template>
    </div>

    <div *ngIf="event.eventData.notifications && event.eventData.notifications.length" class="separator"></div>

    <div class="event-actions" *ngIf="event.eventData.notifications && event.eventData.notifications.length">
      <a class="notification-link" (click)="openNotifications($event)">
        <mat-icon [svgIcon]="'bell-point'" class="notification-icon"></mat-icon>
        <span class="notification-text">{{event.eventData.notifications.length}} {{notificationsHeaderText}}</span>
      </a>
    </div>
  </div>
</div>

<app-location-select-picker #locatinPicker [gpsX]="event.eventData.gpsX" [gpsY]="event.eventData.gpsY" />

<app-lesson-notifications *ngIf="openedNotifications" [notifications]="event.eventData.notifications" [headerText]="notificationsHeaderText" (close)="closeNotifications()" />